import script from "./PropertyInfoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyInfoComponent.vue?vue&type=script&setup=true&lang=js"

import "./PropertyInfoComponent.vue?vue&type=style&index=0&id=a77a7d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a77a7d6c"]])

export default __exports__